import { FC } from 'react';
import { Else, If, Then } from '@edikk-edikk/if';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import { FormattedMessage } from 'react-intl';
import seoBlockActionCss from './assets/seo-block-action.module.scss';
import { useSeoBlockContext } from './hooks';

const SeoBlockAction: FC = () => {
  const { toggle, isVisible } = useSeoBlockContext();
  const isFrontendStyleRed = useIsFrontendStyleRed();

  return (
    <Button
      variant={isFrontendStyleRed ? ButtonVariant.darkTanBrown : ButtonVariant.white}
      additionalClassName={seoBlockActionCss.seoBlockAction}
      onClick={toggle}
    >
      <If condition={isVisible}>
        <Then>
          <FormattedMessage defaultMessage="Hide" />
        </Then>
        <Else>
          <FormattedMessage defaultMessage="Read more" />
        </Else>
      </If>
    </Button>
  );
};

export { SeoBlockAction };
